<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mt-4">

        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-8">
            <table class="min-w-full leading-normal text-gray"
                   style="border: solid 1px #dedede;">
              <thead>
              <tr class="bg-gray-pale">
                <th colspan="12" class="px-2 py-1 text-uppercase">Shares Summary</th>
              </tr>
              </thead>
              <tbody>
              <tr style="border: solid 1px #dedede;" >
                <th class="t-body text-uppercase">
                  Share Capital
                </th>
                <td class="font-bold t-body">
                  {{getCompanyShareClassification?.data?.shareCapital?.toLocaleString()}}
                </td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <th class="t-body text-uppercase">
                  Number of Shares
                </th>
                <td class="font-bold t-body">
                  {{getCompanyShareClassification?.data?.numberOfShares?.toLocaleString()}}
                </td>
              </tr>
              <tr style="border: solid 1px #dedede;">
                <th class="t-body text-uppercase">
                  Number of Un-allotted Shares
                </th>
                <td class="font-bold t-body">
                  {{(getCompanyShareClassification.data.numberOfShares - allottedShares).toLocaleString()}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="grid grid-cols-12 gap-4 mt-4">
          <div class="col-span-12">
            <p class="h5">Share Classification</p>
          </div>
        </div>
        <table class="min-w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead>
            <tr class="bg-gray-pale">
              <th class="px-2 py-1 text-uppercase">Nominal Class</th>
              <th class="px-2 py-1 text-center text-uppercase">Shares</th>
              <th class="px-2 py-1 text-center text-uppercase">Value(UGX)</th>
            </tr>
          </thead>
          <tbody v-for="(cls, idx) in classifications" :key="idx">
          <tr style="border: solid 1px #dedede;" >
            <td class="px-2 py-1 font-bold">
              <span class="text-uppercase" v-if="cls.nominalClass !== 'OTHER'">{{cls.nominalClass.toLowerCase()}}</span>
              <span class="text-uppercase" v-else>{{cls.otherClassName.toLowerCase()}}</span>
            </td>
            <td class="px-2 py-1 text-center font-bold">
              <span v-if="cls.number">{{cls.number.toLocaleString()}}</span>
            </td>
            <td class="px-2 py-1 text-center">
              <span v-if="cls.value && cls.subClasses.length === 0">{{cls.value.toLocaleString()}}</span>
              <span v-else>NIL</span>
            </td>
          </tr>
          <tr style="border: solid 1px #dedede;" v-for="(subClass, idx) in cls.subClasses" :key="idx">
            <td class="px-2 py-1 text-center">
              Class  <span class="text-uppercase">{{subClass.nominalClass.toLowerCase()}}</span>
              <span class="font-monospace text-blue bg-primary-pale px-2 rounded mx-2 text-xs"
                    style="margin-top: 2px; margin-bottom: 2px;">sub-class</span>
            </td>
            <td class="px-2 py-1 text-center">
              <span v-if="subClass.number">{{subClass.number.toLocaleString()}}</span>
            </td>
            <td class="px-2 py-1 text-center">
              <span v-if="subClass.value">{{subClass.value.toLocaleString()}}</span>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="grid grid-cols-12 gap-4 mt-4">
          <div class="col-span-12">
            <p class="h5">Share Holders</p>
          </div>
        </div>
        <table class="min-w-full leading-normal text-gray"
               style="border: solid 1px #dedede;" v-for="(person, idx) in shareholders" :key="idx">
          <thead>
          <tr class="bg-gray-pale">
            <th class="px-2 py-1 text-uppercase">Name</th>
            <th class="px-2 py-1 text-center float-start text-uppercase">Share Class</th>
            <th class="px-2 py-1 text-center text-uppercase">Number of Shares</th>
            <th class="px-2 py-1 text-center text-uppercase">Paid</th>
            <th class="px-2 py-1 text-center text-uppercase">Not Paid</th>
          </tr>
          </thead>
          <thead>
          <tr>
            <td class="px-2 py-1 font-bold text-blue text-uppercase" colspan="12">
              <span>{{person.name}}</span>

            </td>
          </tr>
          </thead>
          <tbody style="border: solid 1px #dedede;" v-for="(share, idx2) in person.shares" :key="idx2" >
          <tr >
            <td class="px-2 py-1"></td>
            <td class="px-2 py-1 text-uppercase font-bold">
              <span v-if="share.nominalClass !== 'OTHER'">{{share.nominalClass}}</span>
              <span v-else>{{share.otherClassName}}</span>
            </td>
            <td class="px-2 py-1 text-center">
                <span v-if="share.subClasses.length === 0">
                  {{share.numberOfShares.toLocaleString()}}
                </span>
            </td>
            <td class="px-2 py-1 text-center">
                <span v-if="share.subClasses.length === 0">
                  {{share.amountPaid.toLocaleString()}}
                </span>
            </td>
            <td class="px-2 py-1 text-center">
                <span v-if="share.subClasses.length === 0">
                  {{share.amountUnPaid.toLocaleString()}}
                </span>
            </td>
          </tr>
          <tr v-for="(subClass, idx3) in share.subClasses" :key="idx3">
            <td class="px-2 py-1"></td>
            <td class="px-2 py-1 text-capitalize">
              <span>Class {{subClass.nominalClass}}</span>
            </td>
            <td class="px-2 py-1 text-center">
                <span>
                  {{subClass.numberOfShares.toLocaleString()}}
                </span>
            </td>
            <td class="px-2 py-1 text-center">
                <span>
                  {{subClass.amountPaid.toLocaleString()}}
                </span>
            </td>
            <td class="px-2 py-1 text-center">
                <span>
                  {{subClass.amountUnPaid.toLocaleString()}}
                </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";

const props = defineProps<{ brn: string }>();

const fileStore = useBusinessFileStore();

const classifications = ref<any[]>([]);
const shareholders = ref<any[]>([]);
const allottedShares = ref(0);

const getCompanyShareClassification = computed(() => fileStore.shares_classification);

onMounted(() => {
  fileStore.fetchCompanyShareClassification(props.brn);
  fileStore.fetchCompanyShareholding(props.brn);
});

watch(() => fileStore.shares_classification, (data) => {
  if (data) {
    classifications.value = data.data.nominalShareClassifications;
  }
});

watch(() => fileStore.shareholding, (data) => {
  if (data) {
    shareholders.value = data.data.content;
    data?.data?.content?.forEach((holder: any) => {
      holder.shares.forEach((share: any) => {
        allottedShares.value += parseInt(share.numberOfShares);
      });
    });
  }
});
</script>

